import React, { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import Dashboard from '../pages/technical/Dashboard'
import Calendar from '../pages/technical/Calendar'
import MenuTechnical from '../components/menus/MenuTechnical'
import Sidebar from '../components/menus/Sidebar'
import { useAuth } from '../components/auth/useAuth'
import i18n from 'i18next'
import MenuMovil from '../components/menus/MenuMovil'
import NothingHere from '../pages/error/NothingHere'
import Version from '../version'
import Protocols from '../pages/technical/Protocols'

const t = i18n.t.bind(i18n)

export default function TechnicalRouter () {
	const navigate = useNavigate()
	const {clientauth} = useAuth()

	useEffect(() => {
		let token = localStorage.getItem('jwt')

		if (!token) {
			navigate(`/${t("url.auth.login")}`)
		}
	}, [navigate])

	const technicalRoutesAlias = {
		"": "dashboard",
		[t("url.technical.dashboard")]: "dashboard",
		[t("url.technical.calendar")]: "calendar",
		[t("url.technical.protocols")]: "protocols"
	}

	const getComponentTechnical = (path) => {
		switch (path) {
			case "dashboard": return <Dashboard/>;
			case "calendar": return <Calendar/>;
			case "protocols": return <Protocols/>;
			default: return <NothingHere />;
		}
	}

	return (
		<Container fluid className='d-flex p-0'>
			<Sidebar rol={clientauth?.rol}/>
			<Container fluid className="contenedor">
				<MenuTechnical roles={clientauth?.roles}/>
				<Routes>
					{Object.entries(technicalRoutesAlias).map(([alias, path]) => (
						<Route key={alias} path={alias} element={getComponentTechnical(path)} />
					))}
					<Route path="*" element={<NothingHere />}/>
				</Routes>
				<div className='text-center mb-2' style={{paddingBottom: "60px"}}>
					<Version />
				</div>
			</Container>
			<MenuMovil />
		</Container>
	)
}